// @ts-nocheck
/* eslint-disable */
export const linearMenuIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="#CECECE" d="M2 4.667h12z"/><path stroke="#CECECE" stroke-linecap="round" stroke-width="1.5" d="M2 4.667h12"/><path fill="#CECECE" d="M2 8h12z"/><path stroke="#CECECE" stroke-linecap="round" stroke-width="1.5" d="M2 8h12M2 11.333h12"/></svg>`,
    name: 'linear-menu' as const
};